import React, { Component } from "react"
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { m } from '../../utils';
import './index.css';
import Loading from '../shared/Loading';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import Button from '../../artzu-ui/src/Button'
import Icon from '../../artzu-ui/src/Icon'
import Calendar from '../../artzu-ui/src/Calendar'
import ViewIndicator from '../NewDash/ViewIndicator'


class CalendarOfBookings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cursor: null
    }
  }

  setCursor = dateString => {
    this.props.handleShiftIndexChange(0);
    this.setState({ cursor: dateString })
  }

  render() {
    const {
      currentMonth,
      nextMonth,
      prevMonth,
      calendarStart,
      calendarEnd,
      formatShift,
      selectBooking,
      selectedBooking,
      shiftIndex,
      handleShiftIndexChange,
      selectedId,
      bookingLink
    } = this.props;

    const {
      cursor
    } = this.state;

    return (
      <Query
        query={bookingLink ? queryWithLink : query}
        fetchPolicy="network-only"
        variables={bookingLink ? {calendarStart, calendarEnd, id: parseInt(bookingLink)} : { calendarStart, calendarEnd }}>
        {({ loading, error, data, refetch }) => {
          if (loading) return <div className="load-div"><Loading size="3x" /></div>;
          let bookings = {}
          let bookingDates = data.currentUserBookings.map(booking => {
            let keyString = m(booking.startTime).toDate().toDateString();
            if(bookings[keyString]) {
              bookings[keyString].push(Object.assign({}, booking));
            } else {
              bookings[keyString] = [Object.assign({}, booking)];
            }
            return m(new Date(booking.startTime));
          })
          if(data.findBooking && !selectedBooking) {
            selectBooking(data.findBooking)
          }
          if(selectedId && !selectedBooking) {
            let booking = data.currentUserBookings.find(book => book.id === selectedId);
            if(booking) selectBooking(booking);
          }
          return (
            <div className="my-bookings-calendar">
              <Calendar
                className="artzu-calendar"
                currentMonth={currentMonth}
                nextMonth={nextMonth}
                prevMonth={prevMonth}
                onDateSelect={date => {
                  let availability = bookings[new Date(date).toDateString()]
                  if(!availability) return null;
                  this.setCursor(date.toDate().toDateString());
                  return 'suggest';
                }}
                onChangeMonth={month => { }}
                selectedShifts={[]}
                flexibleDates={bookings}
                selectedColor="#128dff"
                todayColor="#128dff"
                accordionColor="#414141"
                renderDay={day => {
                  return (
                    <div className="calendar-mark">
                      {
                        bookingDates.find(booked => day.isSame(booked, "day")) ?
                          <FontAwesomeIcon icon={faCircle} style={{fontSize: "6px"}} />
                          : " "}
                    </div>
                  )
                }}>
                {cursor && bookings[cursor] ?
                  <div className="bookings-accordion">
                    <div className="details-div">
                      <div className="details-left">
                        <a className="shift-chevron-left" href="javascript:void(0)" onClick={shiftIndex > 0 ? () => handleShiftIndexChange(shiftIndex - 1) : () => {}}>
                          <Icon name="ChevronLeft" size="sm" color={shiftIndex > 0 ? "#fff" : "#414141"}/>
                        </a>
                        <div className="shift-information">
                          <div className="time-details">
                            <div><b>{m(bookings[cursor][shiftIndex].startTime).format('dddd')},</b></div>
                            <strong>{m(bookings[cursor][shiftIndex].startTime).format('MMM Do, YYYY')}</strong>
                            <p>{formatShift(m(bookings[cursor][shiftIndex].startTime).hour())} to {formatShift(m(bookings[cursor][shiftIndex].endTime).hour())}</p>
                          </div>
                          <div className="earning-details">
                            <strong>Earnings</strong>
                            <p>{m(bookings[cursor][shiftIndex].startTime).isBefore(m()) ? `$${bookings[cursor][shiftIndex].earnings.toFixed(2)}` : "N/A"}</p>
                          </div>
                        </div>
                      </div>
                      <div className="details-right">
                        <div className="shift-information">
                          <div className="vehicle-details">
                            <strong>{bookings[cursor][shiftIndex].parkinglot.region[0].toUpperCase() + bookings[cursor][shiftIndex].parkinglot.region.slice(1)}</strong>
                            <p>{bookings[cursor][shiftIndex].vehicleClass.toUpperCase()}</p>
                          </div>
                          <Button
                            className="details-button"
                            radius="26px"
                            margin="0"
                            primary
                            color="#414141"
                            label="Details"
                            padding="0"
                            onClick={() => {
                              selectBooking(bookings[cursor][shiftIndex], shiftIndex)
                            }}
                          />
                        </div>
                        <a className="shift-chevron-right" href="javascript:void(0)" onClick={shiftIndex < bookings[cursor].length - 1 ? () => handleShiftIndexChange(shiftIndex + 1) : () => {}}>
                          <Icon name="ChevronRight" size="sm" color={shiftIndex < bookings[cursor].length - 1 ? "#fff" : "#414141"}/>
                        </a>
                      </div>
                    </div>
                    <ViewIndicator dots={bookings[cursor].length} index={shiftIndex} active="#fff" inactive="#929292" />
                  </div> : null}
              </Calendar>
            </div>
          )
        }}
      </Query>
    )
  }
}

const query = gql`
  query getCalendar($calendarStart: DateTime!, $calendarEnd: DateTime!) {
      currentUserBookings(startTime: $calendarStart, endTime: $calendarEnd) {
        id
        stringIdentifier
        startTime
        endTime
        vehicleClass
        parkinglot {
          id
          city
          region
          accessCode
          address {
            id
            city
            postalCode
            province
            streetAddress
          }
        }
        duration
        earnings
        car {
          id
          plate
          parkingSpot
          lockboxCode
        }
      }
    }
  `

const queryWithLink = gql`
  query getCalendar($calendarStart: DateTime!, $calendarEnd: DateTime!, $id: Int!) {
      currentUserBookings(startTime: $calendarStart, endTime: $calendarEnd) {
        id
        stringIdentifier
        startTime
        endTime
        vehicleClass
        parkinglot {
          id
          city
          region
          accessCode
          address {
            id
            city
            postalCode
            province
            streetAddress
          }
        }
        duration
        earnings
        car {
          id
          plate
          parkingSpot
          lockboxCode
        }
      }
      findBooking(id: $id) {
        id
        stringIdentifier
        startTime
        endTime
        vehicleClass
        parkinglot {
          id
          city
          region
          accessCode
          address {
            id
            city
            postalCode
            province
            streetAddress
          }
        }
        duration
        earnings
        car {
          id
          plate
          parkingSpot
          lockboxCode
        }
      }
    }
  `

export default CalendarOfBookings;


// WEBPACK FOOTER //
// ./src/components/MyBookings/CalendarOfBookings.js